/**
 * @generated SignedSource<<9daede806c866c2e5624984cf747d0a6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getPdpEstimateSimilarSold_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"showPricingGuidance_item">;
  readonly " $fragmentType": "getPdpEstimateSimilarSold_item";
};
export type getPdpEstimateSimilarSold_item$key = {
  readonly " $data"?: getPdpEstimateSimilarSold_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"getPdpEstimateSimilarSold_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getPdpEstimateSimilarSold_item"
};

(node as any).hash = "9dc26bf37c3a0468939889ef153b1bef";

export default node;
